var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.components),function(component,index){return _c(component.componentName,_vm._b({key:`${component.props?.internalName || component.props?.seoBlockId || component.componentName}-${index}`,tag:"component",staticClass:"render-content"},'component',component.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }